import Model from './Model'

class ServiceCategory extends Model
{
	static Key = 'ServiceCategory';

	static normalize(props)
	{
		props.services = Service.makeMany(
			props.services
		);

		return props;
	}
}

export default class Service extends Model
{
	static Key = 'Service';

    /*
    |--------------------------------------------------------------------------
    | Network Requests
    |--------------------------------------------------------------------------
    */

	static SearchRequest;
	static GetRequest;
    static normalize(props)
    {
        return props;
    }


    shortEstimate() {

        return TB.formatCurrency(
            this.estimated_cost
        )
    }
	static categoryIcon = TB.memoize(this.getCategoryIcon);

	static getCategoryIcon(categoryName) {
		const colors = [
			TB.config('color.info'),
			TB.config('color.success'),
			TB.config('color.danger'),
			TB.config('color.warning'),
			TB.config('color.primary'),
		]

		let display_index = TB.find(laravel.project_template_categories, ['name', categoryName])?.display_index || 0;

		return TB.createStyledCircle(colors[display_index % 5]);
	}

	static categoryIconClass(categoryName) {
		const icons = [
			{ name: 'Strategy & Planning', icon: 'text-white fa-2x far fa-lightbulb' },
			{ name: 'Ecommerce', icon: 'text-white fa-2x fas fa-shopping-cart' },
			{ name: 'Digital Products & Apps', icon: 'text-white fa-2x fas fa-desktop' },
			{ name: 'MarTech', icon: 'text-white fa-2x fas fa-cogs' },
			{ name: 'Data & Measurement', icon: 'text-white fa-2x far fa-chart-bar' },
			{ name: 'AI & Bots', icon: 'text-white fa-2x fas fa-robot' },
			{ name: 'Immersive Experiences', icon: 'text-white fa-2x fas fa-vr-cardboard' },
			{ name: 'CRM & ABM', icon: 'text-white fa-2x fas fa-address-book' },
			{ name: 'Digital Marketing Campaigns', icon: 'text-white fa-2x fas fa-bullhorn' },
			{ name: 'Marketing Websites', icon: 'text-white fa-2x fas fa-globe' },
			{ name: 'Videos / Multi-Media', icon: 'text-white fa-2x fas fa-camera' }
		];
		let matchedIcon = TB.find(icons, ['name', categoryName]) || icons[0];
		return matchedIcon.icon;
	}

	static async search(query, requestOptions = {})
	{
		let user = TB.auth().user();
		if (!user) {
			return;
		}

		let type = (user.isTalent?.()) ? 'talent_service_groups' : 'services'
		this.cancelRequest('SearchRequest');

		this.SearchRequest = TB.request(
			TB.api_endpoint(`/api/${TB.kebabCase(type)}`), {
				search: query,
			}
		);

		let response = await this.SearchRequest.get(requestOptions).catch(console.warn);

		if (!response
			|| !response.success
			|| !response.success.data
			|| !response.success.data[type])
		{
			return;
		}

		return Service.makeMany(
			response.success.data[type]
		);
	}

	static async searchForClient(params = {}, requestOptions = {})
	{
		let user = TB.auth().user();
		if (!user) {
			throw new Error('Unauthorized')
		}

		this.SearchRequest = TB.request(
			TB.api_endpoint(`/api/project-templates`),
			params
		);

		let response = await this.SearchRequest.post(requestOptions).catch(console.warn);

		if (!response
			|| !response.success
			|| !response.success.data
			|| !response.success.data.project_templates)
		{
			throw new Error("Something went wrong")
		}

		return Service.makeMany(
			response.success.data.project_templates
		);
	}

	static async searchForTalent(query, requestOptions = {})
	{
		let user = TB.auth().user();
		if (!user) {
			return;
		}

		let type = 'talent_service_groups'
		this.cancelRequest('SearchRequest');

		this.SearchRequest = TB.request(
			TB.api_endpoint(`/api/${TB.kebabCase(type)}`), {
				search: query,
			}
		);

		let response = await this.SearchRequest.get(requestOptions).catch(console.warn);

		if (!response
			|| !response.success
			|| !response.success.data
			|| !response.success.data[type])
		{
			return;
		}

		return Service.makeMany(
			response.success.data[type]
		);
	}

	static async fetchAll(options)
	{
		let services = await this.search();
		if (!services) {
			return;
		}

		return services;
	}

	static async fetchAllForTalent(options)
	{
		let services = await this.search();
		if (!services) {
			return;
		}
		return services;
	}

	static async fetch(serviceId, full = true)
	{
		let service = this.find(serviceId);

		if (service && (service.deliverables || !full)) return service;

		if(this.GetRequest && this.GetRequest.isRunning()) {
            await this.GetRequest.cancel();
        }

		this.GetRequest = TB.request(TB.api_endpoint(`/api/services/${serviceId}`));

		let response = await this.GetRequest.get().catch(e => {});

		if (!response
			|| !response.success
			|| !response.success.data
			|| !response.success.data.service)
		{
			return;
		}


        service =  this.make({...response.success.data.service});

        if (this.Cached && this.Cached.length) {
			this.Cached = TB.uniqWith([service, ...this.cached()], (object, other) => {
	            return object.id == other.id
	        });
		}

        return service;
	}

	static async fetchTemplate(templateId, requestOptions = {})
	{


		this.GetRequest = TB.request(TB.api_endpoint(`/api/project-templates/${templateId}`));

		let response = await this.GetRequest.get(requestOptions).catch(e => {});

		if (!response
			|| !response.success
			|| !response.success.data
			|| !response.success.data.project_template)
		{
			return;
		}


		return this.make({...response.success.data.project_template});
	}

	static cached()
	{
		return this.Cached ? this.Cached : [];
	}

	static find(serviceId)
	{
		let services = this.cached();

		let service = TB.find(services, ['id', serviceId]);

		if(!service) return false;


		return this.make({...service});
	}
}